<template>
	<div class="main-content-padding" v-if="onlySpVersion">
		<Panel :contentPaddingTop="12" class="comingSoon" style="height: calc(100vh - 100px)">
			<BreadCrumb slot="header"></BreadCrumb>
			<div class="flex flex-just-center align-center" style="margin-top: 100px">
				<emptyPage ref="emptyPage">
					<img slot="image" src="@/assets/public/dev-img.png" alt="" />
					<p class="fz-14 yx-color-text-regular" slot="desc">敬请期待</p>
				</emptyPage>
			</div>
		</Panel>
	</div>
	<div class="main-content-padding" v-else>
		<Panel :contentPaddingTop="12" class="pallet">
			<BreadCrumb slot="header"></BreadCrumb>
			<!---roles 也是菜单权限控制-->
			<div class="mt-12" v-auth="['system:upload-pallet']" v-if="isSallerPatner">
				<el-button type="primary" @click="uploadPallet">上传货盘</el-button>
			</div>
			<div class="search mt-16">
				<yx-search :screenList="screenList" @onSubmit="searchPallet"></yx-search>
			</div>
		</Panel>

		<Panel>
			<multi-table ref="multiTable" :columns="columns" @gePartnerList="getList" :page="pageInfo" :list="list" :total="total">
				<empty :isSearch="isSearch" ref="empty" slot="empty"></empty>
			</multi-table>
		</Panel>

		<remark-dialog ref="remarkDialog" @saveRemark="saveRemark"></remark-dialog>
		<del-dialog ref="delDialog" @delSuccess="getPalletList"></del-dialog>
		<export-dialog @refreshList="getPalletList" ref="exportDialog"></export-dialog>
		<modify-info @refreshList="getPalletList" ref="modifyInfo"></modify-info>
	</div>
</template>
<script>
import { columns, searchColumns } from './columns';
import exportDialog from './components/exportDialog.vue';
import modifyInfo from './components/modifyInfo.vue';
import { palletList, exprotPallet, saveRemark, exprotFailPallet } from '@/api/shopManage';
import remarkDialog from '@/views/shopManage/components/remarkDialog.vue';
import { mapGetters } from 'vuex';
import { palletUploadSomeSuccess, palletUploading, palletUploadFail, menuType } from '@/utils/dataMap';
import delDialog from '@/views/common/dialog/delete.vue';
import empty from '@/views/common/empty/index.vue';
import emptyPage from '@/views/common/empty/index.vue';
export default {
	name: 'pallet',
	components: {
		exportDialog,
		remarkDialog,
		delDialog,
		modifyInfo,
		empty,
		emptyPage,
	},
	data() {
		return {
			columns,
			list: [],
			searchParams: {},
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			total: '',
			isSearch: false,
		};
	},
	computed: {
		...mapGetters(['isSallerPatner', 'onlySpVersion']),
		//过滤要筛选的字段
		screenList() {
			return searchColumns.sort((n1, n2) => n1.searchIndex - n2.searchIndex);
		},
		requestParams() {
			return { page_index: this.pageInfo.page_index, page_size: this.pageInfo.page_size, ...this.searchParams };
		},
	},
	created() {
		this.getPalletList();
	},
	methods: {
		//获取货盘列表
		async getPalletList(isSearch) {
			this.isSearch = Boolean(isSearch);
			const {
				code,
				data: { list = [], page = {} },
			} = await palletList(this.requestParams);
			if (code == 0) {
				this.list = list.map(item => ({
					...item,
					operations: this.getButtons(item),
				}));
				this.total = `${page.item_total}`;
			}
		},
		searchPallet(values) {
			this.searchParams = { ...values };
			this.pageInfo.page_index = 1;
			this.getPalletList(1);
		},
		getButtons({ status, is_self }) {
			const arr = [];
			const notSelf = !is_self;
			// 只有全部上传成功喝部分上传成功有操作按钮
			if (+status !== palletUploading.value) {
				if ([palletUploadSomeSuccess.value, palletUploadFail.value].includes(+status)) {
					arr.push({
						label: '下载失败货盘',
						type: 'text',
						classtype: 2,
						notSelf,
						click: row => {
							if (is_self) {
								this.failPallet(row);
							}
						},
					});
				}
				arr.push(
					{
						label: '删除',
						type: 'text',
						classtype: 2,
						notSelf,
						click: row => {
							if (is_self) {
								this.$refs.delDialog.delInit(row, menuType.pallet, '是否确认删除货盘？');
							}
						},
					},
					{
						label: '导出货盘',
						type: 'text',
						classtype: 2,
						click: row => {
							this.exportPallet(row);
						},
					},
					{
						label: '备注',
						type: 'text',
						classtype: 2,
						notSelf,
						click: row => {
							if (is_self) {
								this.$refs.remarkDialog.remark(row);
							}
						},
					},
					{
						label: '修改货盘联系人',
						type: 'text',
						classtype: 2,
						notSelf,
						click: row => {
							if (is_self) {
								this.$refs.modifyInfo.show(row);
							}
						},
					},
				);
				return arr;
			}
			return arr;
		},
		//上传货盘
		uploadPallet() {
			this.$refs.exportDialog.show();
		},
		//下载失败货盘
		async failPallet({ id: pallet_id }) {
			try {
				const { download_url } = await exprotFailPallet({ pallet_id });
				window.open(download_url, '_blank');
			} catch (error) {
				if (error.code === -1) {
					this.$message.error(error.message);
				}
			}
		},
		//导出货盘
		async exportPallet({ id: pallet_id }) {
			try {
				const { download_url } = await exprotPallet({ pallet_id });
				window.open(download_url, '_blank');
			} catch (error) {
				if (error.code === -1) {
					this.$message.error(error.message);
				}
			}
		},
		//提交备注
		async saveRemark({ id: pallet_id, remark }) {
			let params = {
				pallet_id,
				remark,
			};
			const { code } = await saveRemark(params);
			if (code === 0) {
				this.$message.success('修改成功');
				this.getPalletList();
				this.$refs.remarkDialog.hide();
			}
		},
		getList(obj) {
			const { page_index, page_size } = obj;
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.getPalletList();
		},
	},
};
</script>
